import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userConfirmPassword } from "../../store/auth/actions";
export var UseUserConfirmPassword = function (trigger, bodyRequest) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseConfirmPassword: (_a = state.Login.responseConfirmPassword) === null || _a === void 0 ? void 0 : _a.data,
            errorConfirmPassword: state.Login.errorConfirmPassword,
            loadingConfirmPassword: state.Login.loadingConfirmPassword,
        });
    }), responseConfirmPassword = _a.responseConfirmPassword, errorConfirmPassword = _a.errorConfirmPassword, loadingConfirmPassword = _a.loadingConfirmPassword;
    useEffect(function () {
        if (trigger) {
            dispatch(userConfirmPassword(bodyRequest));
        }
    }, [bodyRequest, trigger]);
    return {
        responseConfirmPassword: responseConfirmPassword,
        errorConfirmPassword: errorConfirmPassword,
        loadingConfirmPassword: loadingConfirmPassword,
    };
};
